// extracted by mini-css-extract-plugin
export default {"PageLayout":"archive-view-module__PageLayout--BQnjg","Box":"archive-view-module__Box--qBBV5"};